import ZJApp from "../../../../app";

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
  service: "EquMonitorService",
  controller: "SysMonEquipment",
};

const methods = [
  "InsertEquipment",
  "UpdateEquipment",
  "DeleteEquipment",
  "BatchUpdateEquipment",
  "BatchUpdateEquipmentStatus",
  "FindEquipmentByPaging",
  "FindAllServerEquipmentByCondition",
  "FindAllServerEquipment",
  "FindEquipmentById",
  "FindEquipmentUseDetail",
];

const factory = (Fun) => {
  utils.extend(Fun.prototype, info);
  methods.forEach((path) => {
    if (path == "FindAllServerEquipment" || path == "FindEquipmentUseDetail") {
      Fun.prototype[path] = function() {
        return this.get(path);
      };
    } else {
      Fun.prototype[path] = function(data) {
        return this.post(path, data);
      };
    }
  });
};

const TranResourcesApi = ZJApi.defineNewApi("TranResourcesApi", factory);

export default TranResourcesApi;
